module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/id/2-7c82ff1e1f5aafc3af4000f37c28f109.jpg";